import React from 'react';
import { BrowserRouter } from 'react-router-dom';
// MUI Components and Config
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

// Internal Components
import { SnackbarProvider } from 'notistack';
import Routes from './Routes';
// App Theme
import { theme } from '../Theme';
// Context
import {
  UserContextProvider,
  AirportContextProvider,
  CountryContextProvider,
  FIRContextProvider,
  MakeAndModelContextProvider,
  AircraftContextProvider,
  AirwayContextProvider,
} from '../Context';
import { GrantContextProvider } from '../Utils/useMyGrants';

const Layout = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <Routes />
      </SnackbarProvider>
    </MuiThemeProvider>
  );
};

/*React Router Wrap*/
const RouterWrapper = () => {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
};

/**Context Wrapper */
function ContextWrapper() {
  return (
    <UserContextProvider>
      <AirportContextProvider>
        <CountryContextProvider>
          <FIRContextProvider>
            <MakeAndModelContextProvider>
              <AircraftContextProvider>
                <AirwayContextProvider>
                  <GrantContextProvider>
                    <RouterWrapper />
                  </GrantContextProvider>
                </AirwayContextProvider>
              </AircraftContextProvider>
            </MakeAndModelContextProvider>
          </FIRContextProvider>
        </CountryContextProvider>
      </AirportContextProvider>
    </UserContextProvider>
  );
}

export default ContextWrapper;
